import React, { useEffect } from 'react';
import styles from '../../styles/cards.module.css'
import { mir } from '../../json/mir';

const Mir = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container transparencia-container'>
            <div className='row'>
                <div className='col_12'>
                    <div className='transparencia_title'>
                        <h3 className={styles.title}>
                            MIR
                        </h3>
                        <hr className='hr-gob'></hr>
                    </div>
                </div>
                {
                    mir.map((item, index)=>(
                        <div key={ index } className='col-md-4 col-sm-6 col-12'>
                            <div className={styles.container}>
                                <h5 className={styles.name}>
                                    {item.year}
                                </h5>
                                <hr></hr>
                                <a href={ item.url } target='_blank' rel='noopener noreferrer'>
                                    <div className={ styles.item }>
                                        <p>
                                            { item.nombre }
                                        </p>
                                        <i className={`${ styles.iconLink } ${ item.icon }`} aria-hidden='true'></i>
                                    </div>
                                </a>
                            </div>
                        </div>
                    ))
                }
                {/*{
              mir.map((item, index)=>(
                item.opcion == 1 ? (
                
                <Link key={ index } to={ item.url ? item.url : "DetalleRubro/" + item.nombre } className='col-md-4 col-sm-6 col-12 rubro_enlace'>
                  <div className='rubro_container'>
                    <div className='rubro_icono'>
                      <img src={"./image/" + item.icono }/>
                    </div>
                    <h3 className='tituloSeccion'>{ item.nombre }</h3>
                  </div>
                </Link>

                ):(
                <a href={ item.url } target="_blank" className='col-md-4 col-sm-6 col-12 rubro_enlace'>
                  <div className='rubro_container'>
                    <div className='rubro_icono'>
                      <i className='paaas-img icon-indicators'></i>
                    </div>
                    <h3 className='tituloSeccion'>{ item.nombre }</h3>
                  </div>
                </a>)
                
              ))
              
            }*/}
            </div>
        </div>
    )
}

export default Mir